/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ShareIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M11.535 2.955a.666.666 0 0 1 .93 0l5.324 5.203a1.044 1.044 0 0 1-1.46 1.493l-3.273-3.2v8.834a1.056 1.056 0 0 1-2.112 0V6.45L7.67 9.65a1.044 1.044 0 0 1-1.459-1.492zM2.5 18.405v-3.072a1.056 1.056 0 1 1 2.111 0v3.072c0 .57.473 1.031 1.056 1.031h12.666c.583 0 1.056-.462 1.056-1.031v-3.072a1.056 1.056 0 1 1 2.111 0v3.072c0 1.71-1.418 3.095-3.167 3.095H5.667c-1.75 0-3.167-1.386-3.167-3.095" /></svg>;
};
export default ShareIcon;